import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
    locale: 'it',
    fallbackLocale: 'it',
    silentTranslationWarn: process.env.NODE_ENV !== 'production',
    messages: {
        'it': {
            alerts: {
                empty: {
                    title: 'No Data found',
                    text: 'Some functions need more Data',
                    short: 'Needs more data'
                },
                error: {
                    title: 'Error while execution',
                    text: 'There was an Error while executing this task. Changes may not be saved or the Application is in Error.'
                },
                success: {
                    title: 'Success',
                    text: 'Changes successfully saved'
                },
                expired: {
                    title: 'Session expired',
                    text: 'Your Session expired. Please login again.'
                }
            },
            views: {
                Home: 'Home',
                Accedi: 'Accedi',
                Appuntamenti: 'Appuntamenti',
                Calendario: 'Calendario',
                Servizi: 'Servizi',
                Clienti: 'Clienti',
                Asilo: 'Asilo',
                Pensione: 'Pensione',
                Allevamento: 'Allevamento'
            },
            errors: {
                valid: 'Value has to be valid',
                required: 'Value is required'
            }
        },
        'en': {
            views: {
                Home: 'Home',
                Accedi: 'Log in',
                Appuntamenti: 'Appointments',
                Calendario: 'Calendario',
                Servizi: 'Servizi',
                Clienti: 'Clienti',
                Asilo: 'Asilo',
                Pensione: 'Pensione',
                Allevamento: 'Allevamento'
            },
            errors: {
                valid: 'Value has to be valid',
                required: 'Value is required'
            }
        },
    }

})
